// 地面站设置
export default {
    language: '语言',
    company: '参数单位',
    metricSystem: '公制(m/s)',
    britishSystem: '英制(mph)',
    trajectory: '飞行轨迹',
    trajectoryShow: '显示',
    trajectoryHide: '隐藏',
    mapCenter: '地图中心',
    lng: '经度',
    lat: '纬度',
    baseStationSettings: '基站设置',
    cloudBasedStation: '云基站',
    mobileBasedStation: '移动基站',
    messageSettings: '消息设置',
    AP: '异常提示',
    SP: '系统推送',
    basicSettings: '基础设置',
    DID: '默认信息显示',
    BSD: '基站显示',
    NFZD: '禁飞区显示',
    WDV: '航点默认值',
    WH: '高度',
    WS: '速度',
    WR: '半径',
    HT: '悬停时间',
    HM: '航点模式',
    circlingDirection: '盘旋方向',
    clockwise: '顺时针',
    counterclockwise: '逆时针',
    PTDV: '指点默认值',
    waitingTime: '等待时间',
    circlingRadius: '盘旋半径',
    cycles: '循环次数',
    tip_PELng: '请输入经度',
    tip_PELat: '请输入纬度',
    tip_PEAI: '请输入整数',
    tip_IAL: '0是一直循环',
    tip_ETNO: '循环次数输入错误',
}